import config from "config/config.js";

const duplicateUsername = (username, timestamp) => {
  const endpoint = `${
    config.baseUrl
  }/api/user/duplicate/${username}/${timestamp}`;
  const options = {
    method: "get",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(res => {
      return res;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errrr", e);
    });
};

export default duplicateUsername;
